import { useState } from "react";

export function ExportHook(props: {
  fileName: string;
  children: (
    open: () => void,
    state: { loading: boolean }
  ) => React.ReactElement;
  requestApi: () => Promise<any>;
  onOk: (data: any) => void;
}) {
  const [state, setState] = useState({ loading: false });

  return props.children(() => {
    if (state.loading) return;
    setState((v) => ({ ...v, loading: true }));
    props
      .requestApi()
      .then((data) => {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", props.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        props.onOk(data);
      })
      .finally(() => setState((v) => ({ ...v, open: false, loading: false })));
  }, state);
}
